import Section from '@cell/cell-core/component/section';
import './product-recommendations.scss';

class ProductRecommendations extends Section {
  constructor() {
    super();
  }

  componentDidMount() {
    const handleIntersection = async (entries, observer) => {
      if (!entries[0].isIntersecting) return;

      observer.unobserve(this);

      const res = await fetch(this.parsedDataset.url);
      const html = await res.text();

      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      this.innerHTML = doc.querySelector(this.tagName).innerHTML;
    };

    const intersectionObserver = new IntersectionObserver(handleIntersection, {
      rootMargin: '0px 0px 0px 0px',
    });

    intersectionObserver.observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);
